var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5832 31.8327C27.9369 31.8327 28.276 31.6922 28.5261 31.4421C28.7761 31.1921 28.9166 30.853 28.9166 30.4993V9.13001C28.9159 7.01758 28.0762 4.99192 26.5823 3.49845C25.0883 2.00499 23.0623 1.16602 20.9499 1.16602H4.91658C4.56296 1.16602 4.22382 1.30649 3.97378 1.55654C3.72373 1.80659 3.58325 2.14573 3.58325 2.49935V30.4993C3.58325 30.853 3.72373 31.1921 3.97378 31.4421C4.22382 31.6922 4.56296 31.8327 4.91658 31.8327H27.5832Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 1.27148V6.49949C22.25 6.85311 22.3905 7.19225 22.6405 7.4423C22.8906 7.69234 23.2297 7.83282 23.5833 7.83282H28.81",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5552 20.5C11.5552 21.0304 11.3445 21.5391 10.9694 21.9142C10.5943 22.2893 10.0856 22.5 9.55518 22.5H7.55518V18.5H9.55518C10.0856 18.5 10.5943 18.7107 10.9694 19.0858C11.3445 19.4609 11.5552 19.9696 11.5552 20.5Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55518 26.498V22.498",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2219 18.5C15.2828 18.5 16.3002 18.9214 17.0504 19.6716C17.8005 20.4217 18.2219 21.4391 18.2219 22.5C18.2219 23.5609 17.8005 24.5783 17.0504 25.3284C16.3002 26.0786 15.2828 26.5 14.2219 26.5V18.5Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8885 26.5V19.8333C20.8885 19.4797 21.029 19.1406 21.2791 18.8905C21.5291 18.6405 21.8683 18.5 22.2219 18.5H24.8885",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8885 22.498H23.5552",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBlack);
export default __webpack_public_path__ + "static/media/pdf-black.3b8d7ab828804a9f6fa8f59f4f96820c.svg";
export { ForwardRef as ReactComponent };